import React from "react"
import PropTypes from "prop-types"

import Layout from "../components/layout"

// Utilities
import kebabCase from "lodash/kebabCase"
import { RiHome2Line } from "react-icons/ri"

// Components
import { Helmet } from "react-helmet"
import { Link, graphql } from "gatsby"

const TagsPage = ({
  data: {
    allMarkdownRemark: { group },
    site: {
      siteMetadata: { title },
    },
  },
}) => (
  <Layout className="blog-page">
    <Helmet title={"タグリスト | " + title} />
    <div>
      <h1 className="taxonomy-header">タグリスト</h1>
      <ul className="tags-list">
        {group.map(tag => (
          <li key={tag.fieldValue}>
            <Link to={`/tags/${kebabCase(tag.fieldValue)}/`}>
              # {tag.fieldValue} <span>{tag.totalCount}</span>
            </Link>
          </li>

        ))}
      </ul>
      <div className="back-to-home">
      <Link to="/"><RiHome2Line />サイトトップへ</Link>
      </div>
    </div>
    </Layout>
)

TagsPage.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      group: PropTypes.arrayOf(
        PropTypes.shape({
          fieldValue: PropTypes.string.isRequired,
          totalCount: PropTypes.number.isRequired,
        }).isRequired
      ),
    }),
    site: PropTypes.shape({
      siteMetadata: PropTypes.shape({
        title: PropTypes.string.isRequired,
      }),
    }),
  }),
}

export default TagsPage

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(limit: 2000) {
      group(field: frontmatter___tags) {
        fieldValue
        totalCount
      }
    }
  }
`